import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { BoxComponent } from './box/box.component';
import { BoxResultType } from '@reporting-proxies';

@Component({
    selector: 'app-report-boxes-wrapper',
    standalone: true,
    imports: [BoxComponent],
    templateUrl: './boxes-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./boxes-wrapper.component.scss']
})
export class ReportBoxesWrapperComponent {
    boxesValues = input<BoxResultType[]>([]);
    gridArea = input<string>();
}
